import React from "react";
// import HeroImage from "../assets/heroImage.png";
// import HeroImage from "../assets/myphoto.jpg";
import HeroImage from "../assets/myimage.svg";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import { Link } from "react-scroll";


const Home = () => {
    const openToWork = true;

    return (
        // This is total home page
        <div
            name="home"
            className="w-full h-auto
                bg-gradient-to-b from-black via-black to-gray-800 md:h-screen"
        >
            <div className="pt-24 md:pt-0 max-w-screen-lg mx-auto flex flex-col items-center justify-center 
                h-full px-4 md:flex-row">
                {/* This is for bio details */}
                <div data-aos="fade-right" className="flex flex-col justify-center h-full md:w-1/2 sm:w-1/2">
                    <div className="space-y-1 sm:space-y-2">
                        <div className="flex items-center justify-between">
                            <h2 className="flex flex-row text-2xl sm:text-3xl font-bold text-white">
                                Hello<span className="animate-wave origin-bottom-right">👋</span>
                                {/* <span className="text-sm font-normal">Good Morning</span> */}
                            </h2>
                            <div className="mr-4 md:mr-16">
                                {/* <span className="bg-green-900 text-green-300 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full">User</span> */}
                                {
                                    openToWork && (
                                        <span className="bg-blue-700 text-blue-100 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full">
                                            Open To Work
                                        </span>)
                                }
                            </div>
                        </div>
                        <h2 className="text-3xl sm:text-5xl font-bold text-white">
                            <span className="font-signature">I am Molla Mainuddin</span>
                        </h2>
                        <h2 className="text-2xl sm:text-3xl font-bold text-white">
                            Full Stack Developer
                        </h2>
                    </div>
                    <p className="text-gray-300 py-4 max-w-md text-base md:text-lg">
                    I have 3+ years of experience specializing in the Java Full Stack domain. 
                    My expertise lies in building robust, scalable web applications using technologies such as Java, Spring Boot, MicroServices, React. 
                    With a strong commitment to delivering high-quality solutions, I thrive on turning complex problems into elegant, user-friendly designs.
                    </p>
                    {/* This is for portfolio button */}
                    <div>
                        <Link
                            to="projects"
                            smooth
                            duration={500}
                            offset={-70}
                            className="group text-white w-fit px-2 md:px-6 py-2 md:py-3 my-2 md:flex items-center rounded-md 
                            bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer hidden"
                        >
                            Projects
                            <span className="group-hover:rotate-90 duration-300">
                                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
                            </span>
                        </Link>
                        <a
                            href="/Molla Mainuddin.pdf"
                            target="_blank"
                            rel="noreferrer"
                            className="group text-white w-fit px-4 py-2 my-2 
                                flex items-center rounded-md md:hidden
                                bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
                        >
                            <span className="">
                                <FaEye size={15} className="text-white mr-1" />
                            </span>
                            My Resume
                        </a>
                    </div>
                </div>
                {/* This is for image  */}
                <div data-aos="fade-left" className="md:w-1/2 sm:w-1/2 px-4 md:px-0 py-6 md:pt-14 md:pb-0">
                    <div className="">
                        <img
                            src={HeroImage}
                            alt="my profile"
                            // className="rounded-2xl mx-auto w-2/3 md:w-full"
                            className="mx-auto w-full"
                        />
                    </div>
                    {/* <span onClick={() => alert("Hello")} className="sm:hidden absolute inline-flex rounded-full h-1 w-1 bg-white top-[44.2%] right-[32.3%]"></span> */}
                </div>
            </div>
        </div>
    );
};

export default Home;
